const styles = (theme) => ({
  modalTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  titleField: {
    mt: 1,
    mb: 2,
  },
  iconLabel: {
    fontSize: 12,
    fontWeight: 700,
    color: theme?.palette?.text?.secondary,
    mb: 0.5,
  },
  // Área do cropper: fundo escuro fixo para destacar a máscara circular em qualquer tema
  cropStage: {
    position: "relative",
    width: "100%",
    height: 220,
    borderRadius: 2,
    overflow: "hidden",
    backgroundColor: "#1c1c1c",
  },
  zoomRow: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    mt: 1.5,
  },
  zoomSlider: {
    flex: 1,
    cursor: "pointer",
    accentColor: theme?.palette?.primary?.main,
  },
  trocarImagemButton: {
    mt: 1,
    textTransform: "none",
  },
});

export default styles;
